import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import './Footer.css'
import { renderTextWithNormalDash } from '../../utils/textFormatters'

const Footer = () => {
    return (
        <footer className="site-footer">
            <Container className="footer-container">
                <Row className="gy-4">
                    <Col md={6} className="footer-brand">
                        <img src="/elite-optix-logo.png" alt="Elite Optix" className="footer-logo" />
                        <p className="footer-desc">Elite Optix combines professional eye treatment with handmade luxury eyeglasses. Our boutique experience ensures that you depart with improved vision and an upgraded style.</p>

                    </Col>

                    <Col md={2} className="footer-links">
                        <h6>Quick Link:</h6>
                        <ul>
                            <li><Link to="/home">HOME</Link></li>
                            <li><Link to="/about">ABOUT</Link></li>
                            <li><Link to="/services">SERVICES</Link></li>
                            <li><Link to="/insights">INSIGHTS</Link></li>
                            <li><Link to="/contact">CONTACT</Link></li>
                        </ul>
                    </Col>
                    <Col md={2} className="footer-links">
                        <h6>Services:</h6>
                        <ul>
                            <li><Link to="/services/sunglasses">SUNGLASSES</Link></li>
                            <li><Link to="/services/eye-exam">EYE EXAM</Link></li>
                            <li><Link to="/services/safety-glasses">SAFETY GLASSES</Link></li>
                            <li><Link to="/services/eye-glasses">EYE GLASSES</Link></li>
                            <li><Link to="/services/sports-goggles">SPORTS GOGGLES</Link></li>
                            <li><Link to="/services/contact-lenses">CONTACT LENSES</Link></li>
                        </ul>
                    </Col>

                    <Col md={2} className="footer-contact">
                        <h6>Contact:</h6>
                        <ul>
                            <li>{renderTextWithNormalDash("(416) 746-2626")}</li>
                            <li>{renderTextWithNormalDash("2930 ISLINGTON AVE, TORONTO, ON")}</li>
                            <li><a href="mailto:info@eliteoptix.ca" className='text-decoration-none'>{renderTextWithNormalDash("INFO@ELITEOPTIX.CA")}</a></li>
                            <li>{renderTextWithNormalDash("MON–FRI: 9AM–6PM")}</li>
                        </ul>
                    </Col>
                </Row>

                <Row className="mt-4">
                    <div className="footer-divider" />
                    <Col xs={12} sm={4} lg={4} xl={4}>
                        <div className="footer-socials">
                            <Link to="https://www.facebook.com/share/1G71QrXYay/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><img src="/icons/facebook.png" alt="facebook" /></Link>
                            <Link to="https://www.instagram.com/elite.optix?igsh=MWY2bWZuMjBwMTMxMA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer"><img src="/icons/Instagram.png" alt="instagram" /></Link>
                            <Link to="https://www.linkedin.com/company/elite-optix/" target="_blank" rel="noopener noreferrer"><img src="/icons/linkedin.png" alt="linkedin" /></Link>
                        </div>
                    </Col>
                    <Col xs={12} sm={5} lg={5} xl={5} className="text-sm-center">
                        <div className="footer-createdby">Created by <Link to="https://www.creativesquad.ca/" className='text-decoration-none' target="_blank" rel="noopener noreferrer">Creative Squad Inc</Link></div>
                    </Col>
                    <Col className='text-sm-end'>
                        <div className="footer-copyright">© {new Date().getFullYear()} Elite Optix. All rights reserved.</div>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer
/* removed duplicate stub */